import React from 'react';
import classNames from 'classnames';

import { FormattedMessage } from '../../util/reactIntl';
import { LISTING_STATE_DRAFT } from '../../util/types';
import { types as sdkTypes } from '../../util/sdkLoader';

import { H3, ListingLink } from '../../components';

import EditListingAddOnsForm from './EditListingAddOnsForm';
import css from './EditListingAddOnsPanel.module.css';

const { Money } = sdkTypes;

const getInitialValues = listing => {
  const { price, publicData } = listing?.attributes || {};
  const addOns = publicData?.addOns || [];

  const addOnsAsMoney = addOns.map(addOn => {
    const { name, price: { amount, currency } } = addOn;
    return { name, price: new Money(amount, currency) };
  });

  return { price, addOns: addOnsAsMoney };
};

const EditListingAddOnsPanel = props => {
  const {
    className,
    rootClassName,
    listing,
    marketplaceCurrency,
    listingMinimumPriceSubUnits,
    disabled,
    ready,
    onSubmit,
    submitButtonText,
    panelUpdated,
    updateInProgress,
    errors,
  } = props;

  const classes = classNames(rootClassName || css.root, className);
  const initialValues = getInitialValues(listing);
  const isPublished = listing?.id && listing?.attributes?.state !== LISTING_STATE_DRAFT;
  const priceCurrencyValid =
    marketplaceCurrency && initialValues.price instanceof Money
      ? initialValues.price.currency === marketplaceCurrency
      : !!marketplaceCurrency;
  const unitType = listing?.attributes?.publicData?.unitType;

  return (
    <div className={classes}>
      <H3 as="h1">
        {isPublished ? (
          <FormattedMessage
            id="EditListingAddOnsPanel.title"
            values={{ listingTitle: <ListingLink listing={listing} /> }}
          />
        ) : (
          <FormattedMessage id="EditListingAddOnsPanel.createListingTitle" />
        )}
      </H3>
      {priceCurrencyValid ? (
        <EditListingAddOnsForm
          className={css.form}
          initialValues={initialValues}
          onSubmit={values => {
            const { addOns = [] } = values;
            const addOnsAsPublicData = addOns.map(addOn => ({
              name: addOn.name,
              price: { amount: addOn.price.amount, currency: addOn.price.currency },
            }));

            onSubmit({
              publicData: { addOns: addOnsAsPublicData },
            });
          }}
          marketplaceCurrency={marketplaceCurrency}
          unitType={unitType}
          saveActionMsg={submitButtonText}
          disabled={disabled}
          ready={ready}
          updated={panelUpdated}
          updateInProgress={updateInProgress}
          fetchErrors={errors}
        />
      ) : (
        <div className={css.priceCurrencyInvalid}>
          <FormattedMessage
            id="EditListingAddOnsPanel.listingPriceCurrencyInvalid"
            values={{ marketplaceCurrency }}
          />
        </div>
      )}
    </div>
  );
};

export default EditListingAddOnsPanel;
